import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  makeStyles,
  Tab,
  Tabs,
} from '@material-ui/core'
import { UIRegionOfInterest } from '../../UIRegionOfInterest'
import SelectedColumnRow from './SelectedColumnRow'
import { useSelectedColumnsContext } from '../../../../SelectedColumnsProvider'

const useStyles = makeStyles((theme) => ({
  main: {
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    display: 'flex',
    width: '700px',
  },
  tabs: {
    borderLeft: `1px solid ${theme.palette.divider}`,
    minWidth: 60,
    maxWidth: 70,
    '& .MuiTab-wrapper': {
      alignItems: 'flex-start',
      textAlign: 'left',
    },
    '& .MuiTab-root': {
      justifyContent: 'flex-start',
      textAlign: 'left',
    },
  },
  tabLabel: {
    fontSize: '0.7rem',
    textTransform: 'none',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
    overflowY: 'auto',
  },
}))

type SelectedColumnListProps = {
  selectedPageNumber: number
  focusedRegionOfInterest: UIRegionOfInterest | null
  setFocusedRegionOfInterest: (regionOfInterest: UIRegionOfInterest | null) => void
  setSelectedPageNumber: (pageNumber: number) => void
}

export default function SelectedColumnList({
  selectedPageNumber,
  focusedRegionOfInterest,
  setFocusedRegionOfInterest,
  setSelectedPageNumber,
}: SelectedColumnListProps) {
  const classes = useStyles()
  const { getRegionsForPage, pageToSelectedColumns } = useSelectedColumnsContext()

  const regions = getRegionsForPage(selectedPageNumber)
  const pagesWithRegions = Array.from(pageToSelectedColumns.keys())

  return (
    <Box className={classes.main} boxShadow={2}>
      <Box className={classes.content}>
        <List
          aria-labelledby='nested-list-subheader'
          subheader={<ListSubheader>Selected Columns</ListSubheader>}
        >
          {regions && regions.length > 0 ? (
            regions.map((t, i) => (
              <SelectedColumnRow
                key={i}
                pageNumber={selectedPageNumber}
                markupIdx={i}
                regionsOfInterest={t}
                focusedRegionOfInterest={focusedRegionOfInterest}
                focusOnRegionOfInterest={setFocusedRegionOfInterest}
              />
            ))
          ) : (
            <ListItem>
              <ListItemText primary='No Columns Selected' />
            </ListItem>
          )}
        </List>
      </Box>

      <Tabs
        orientation="vertical"
        value={selectedPageNumber}
        onChange={(e, newPage) => setSelectedPageNumber(newPage)}
        className={classes.tabs}
      >
        {pagesWithRegions.map((page) => (
          <Tab
            key={page}
            label={`Page ${page}`}
            value={page}
            classes={{ wrapper: classes.tabLabel }}
          />
        ))}
      </Tabs>
    </Box>
  )
}
